// extracted by mini-css-extract-plugin
export default {"dlDataChangesItem":"src-js-containers-auto_layout-components-DataChanges---dlDataChangesItem---XGfMH"};